// eslint-disable-next-line
import React from "react";
import HomeBG from "../../assets/Home/homefinal@2x.png";

// eslint-disable-next-line

import Container from "../../Components/Container";
import BlueLogo from "../../assets/momentumlogoblue@2x.png";
import styled from "styled-components";
import MARKETAMERICA from "../../assets/Home/MARKETAMERICA@2x.png";
import MomentumSolarText from "../../assets/Home/momentumSOLAR@2x.png";

const HomeStyles = styled.div`
  .main {
    background-size: 100% 100%;
    background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.4),
        rgba(0, 0, 0, 0.2)
      ),
      url(${HomeBG});
    background-color: rgba(235, 235, 235, 0.2);
    z-index: 2;
    padding: 30px 10px 16px 30px;
    position: relative;
    height: 100%;
    width: 100vw;

    display: grid;
    grid-template-rows: 180px 1fr auto;
  }

  .top {
  }

  .momentum-solar {
    font-size: 52px;
    font-weight: 500;
    .momentum {
      text-transform: lowercase;
      color: white;
      margin-right: 10px;
    }
    .solar {
      color: #00ccff;
      font-size: 42px;
    }
  }

  .service-copy {
    /* margin-top: 10px; */
    color: white;
    font-size: 20px;
    font-weight: 400;
    grid-gap: 2px;
    display: grid;
    text-transform: uppercase;
  }
  .bottom {
    display: grid;
    align-content: end;
    grid-auto-flow: column;
    grid-gap: 12px;
    align-items: center;
    grid-template-columns: 90px 1fr;

    img {
      height: 70px;
    }
  }
  .copy {
    font-family: lato;
    font-weight: 500;
    color: white;
    font-size: 16px;
    display: grid;
    grid-gap: 10px;
  }
`;

const Home = () => {
  return (
    <Container initial="hidden" animate="show" exit="exit">
      <HomeStyles>
        <div className="main">
          <div className="top">
            <div className="momentum-solar">
              <img
                alt="momentum"
                style={{ width: "55%" }}
                src={MomentumSolarText}
              />
              {/* <span className="momentum">momentum</span>
              <span className="solar">SOLAR</span> */}
            </div>
            <div className="service-copy">
              <span> Unparalleled customer service. </span>

              <span> Measurable financial savings.</span>
              <span> Unrivalled aesthetic appeal.</span>
            </div>
          </div>

          <div className="bottom">
            <div className="logo">
              <img alt="momentum" src={BlueLogo} />
            </div>
            <div className="market-logo">
              <img alt="momentum" src={MARKETAMERICA} />
            </div>
          </div>
        </div>
      </HomeStyles>
    </Container>
  );
};

export default Home;
